import { inject } from '@angular/core';
import type { CanDeactivateFn } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { BasicModalComponent } from '../modals/basic-modal/basic-modal.component';
import { BasicModalCta, BasicModalIcon } from '../modals/basic-modal/basic-modal.types';
import type { HasPendingChanges } from '../types/has-pending-changes.interface';

let activeConfirmation: Promise<boolean> | undefined;

export const pendingChangesGuard: CanDeactivateFn<HasPendingChanges> = (component) => {
  if (!component.hasPendingChanges()) {
    return true;
  }

  if (activeConfirmation) {
    return activeConfirmation;
  }

  const modal = inject(NgbModal);
  const translate = inject(TranslateService);
  const modalRef = modal.open(BasicModalComponent, {
    ariaDescribedBy: 'basic-modal-description',
    ariaLabelledBy: 'basic-modal-title',
    backdrop: 'static',
    beforeDismiss: () => false,
    centered: true,
    keyboard: false,
    role: 'alertdialog',
  });
  const modalComponent = modalRef.componentInstance as BasicModalComponent;

  modalComponent.icon = BasicModalIcon.Warning;
  modalComponent.title = translate.instant('modals.pendingChanges.title');
  modalComponent.description = translate.instant('modals.pendingChanges.description');
  modalComponent.mainCtaText = translate.instant('modals.pendingChanges.mainCta');
  modalComponent.alternativeCtaText = translate.instant('modals.pendingChanges.alternativeCta');

  activeConfirmation = modalRef.result
    .then(
      (result: unknown) => result === BasicModalCta.Main,
      () => false,
    )
    .finally(() => {
      activeConfirmation = undefined;
    });

  return activeConfirmation;
};
